import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Label } from "./anim";
import { MANIFESTO } from "../data/content";

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["8%", "-8%"]);

  return (
    <section
      id="approach"
      ref={ref}
      data-testid="manifesto-section"
      className="relative bg-[#EFEBDE] py-24 md:py-40 overflow-hidden"
    >
      {/* parallax eco-architecture image */}
      <motion.div style={{ y }} className="absolute right-0 top-0 h-full w-1/2 opacity-[0.16] pointer-events-none hidden lg:block">
        <img
          src="https://images.unsplash.com/photo-1565599573128-ae3ef5c9f478?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent to-[#EFEBDE]" />
      </motion.div>

      <div className="relative max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <Label>The Approach</Label>
          <h2 className="mt-6 font-display font-semibold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.95] max-w-3xl text-[#16281C]">
            How complex projects get approved.
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24 max-w-4xl">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.num} delay={i * 0.05}>
              <div className="group grid grid-cols-[auto_1fr] gap-6 md:gap-12 py-8 md:py-10 border-t border-[#16281C]/12 last:border-b">
                <span className="font-mono font-semibold text-4xl md:text-6xl text-stroke group-hover:text-[#2C5F3A] group-hover:[-webkit-text-stroke:0] transition-all duration-500">
                  {m.num}
                </span>
                <div>
                  <h3 className="font-display font-semibold text-2xl md:text-4xl tracking-tight text-[#16281C] group-hover:translate-x-2 transition-transform duration-500">
                    {m.title}
                  </h3>
                  <p className="mt-3 font-body text-base md:text-lg text-[#4C5C50] leading-relaxed max-w-2xl">
                    {m.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
